<template>
  <v-card>
    <v-card-title>
      Users
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-simple-table v-if="users">
        <thead>
          <tr>
            <th>ID</th>
            <th>Provider Platform ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Last Login</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in showUsers" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.connectId }}</td>
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.role }}</td>
            <td>
              <span v-if="user.lastLoginAt">{{
                user.lastLoginAt | dateTime
              }}</span>
            </td>
            <td>
              <span v-if="user.createdAt">{{ user.createdAt | dateTime }}</span>
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    v-on="on"
                    :to="{ name: 'UserShow', params: { userId: user.id } }"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>View User</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    v-on="on"
                    :to="{ name: 'UserEdit', params: { userId: user.id } }"
                  >
                    <v-icon>mdi-account-edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit User</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        fab
        bottom
        right
        small
        color="primary"
        :to="{
          name: 'NewCompanyUser',
          params: { companyId: $route.params.companyId }
        }"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getCompanyUsers } from "../../api/company";

export default {
  name: "Users",
  title: "Users",

  data() {
    return {
      users: [],
      search: ""
    };
  },

  computed: {
    showUsers() {
      if (this.search) {
        const search = this.search.toLowerCase();
        return this.users.filter(
          user =>
            user.firstName.toLowerCase().includes(search) ||
            user.lastName.toLowerCase().includes(search) ||
            user.email.toLowerCase().includes(search)
        );
      }
      return this.users;
    }
  },

  props: {
    companyId: [String, Number]
  },

  mounted() {
    this.getUsers();
  },

  methods: {
    async getUsers() {
      const companyId = parseInt(this.companyId);
      if (companyId) {
        this.loading = true;
        const result = await getCompanyUsers(companyId);
        this.users = result.users;
        this.loading = false;
      }
    }
  }
};
</script>
